/* eslint-disable array-callback-return */
import React, { useState, useRef, useContext, useEffect } from "react"
import { Fieldset } from "primereact/fieldset"
import PropTypes from "prop-types"
import { Toast } from "primereact/toast"
import { Toolbar } from "primereact/toolbar"
import CustomToolBar from "../../../ToolBar/customToolbar"
import ServicesRow from "../../B/PlannedServices/ServicesRow"
import { errorMessages } from "../../../types/messages"
import {
  existsErrors,
  getAdditionalQuestions,
  showMessage,
  showQuestion,
  updateState,
  validateQuestions,
  formatMixedQuestions,
  filterAdditionalQuestions,
  checkDisplayConditional,
  checkConditionalRender,
  prevForm,
  nextForm,
} from "../../../utils/utils"
import { GpraContext } from "../../../../../context/gpraContext"
import { endpoints } from "../../../../../config/gpraApiEndpoints"
import FormLabel from "../../../Common/FormLabel"
import FormError from "../../../Common/FormError"
import gpraStyles from "../../../../../styles/Participant-GPRA.module.css"
import { INTERVIEW_SECTIONS } from "../../../types/interviewTypes"
import { InputText } from "primereact/inputtext"
import AdditionalQuestionContainer from "../../Additional/AdditionalQuestionContainer"
import { UserContext } from "../../../../../context/userContext"

const ServicesReceived1 = (props) => {
  const { showToolBar, disabled } = props
  const {
    handleSubmitPut,
    interview,
    handleLoadPrev,
    handleLoadNext,
    handleSectionsCompleted,
    sectionsCompleted,
    questions,
    updateInterviewValues,
    additionalQuestions,
    sections,
    activeIndex,
    administrativeInterview,
    editMode,
  } = useContext(GpraContext)

  const userCtx = useContext(UserContext)

  const [servicesReceived1, setServicesReceived1] = useState(
    interview[INTERVIEW_SECTIONS.SERVICES_RECEIVED_1]
  )
  const [validationErrors, setValidationErrors] = useState({})
  const [mixedQuestions, setMixedQuestions] = useState([])
  const toast = useRef(null)
  
  useEffect(() => {
    if (mixedQuestions.length === 0) {
      let filteredQuestions = []
      let filteredAdditional = []
      if (questions) {
        filteredQuestions = questions.filter(
          (q) => q.section === INTERVIEW_SECTIONS.SERVICES_RECEIVED_1
        )
      }
      if (additionalQuestions) {
        filteredAdditional = filterAdditionalQuestions(
          additionalQuestions,
          INTERVIEW_SECTIONS.SERVICES_RECEIVED_1
        )
      }
      setMixedQuestions(
        formatMixedQuestions(filteredQuestions, filteredAdditional)
      )
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [questions, additionalQuestions])
  
  const saveData = (setNextForm, previousForm, setNavigationItem) => {
    updateInterviewValues(
      INTERVIEW_SECTIONS.SERVICES_RECEIVED_1,
      servicesReceived1
    )
    if (previousForm) {
      handleLoadPrev(true)
      setNextForm(prevForm(sections, activeIndex, administrativeInterview))
      setNavigationItem()
    } else {
      if (validForm()) {
        handleLoadNext(true)
        handleSubmitPut(endpoints.SAVE_SERVICESRECEIVED1_DATA, {
          GpraKMod1: servicesReceived1?.gpra_k_mod_1,
          GpraKMod2: servicesReceived1?.gpra_k_mod_2,
          GpraKMod3: servicesReceived1?.gpra_k_mod_3,
          GpraKMod4: servicesReceived1?.gpra_k_mod_4,
          GpraKMod5: servicesReceived1?.gpra_k_mod_5,
          GpraKMod6a: servicesReceived1?.gpra_k_mod_6a,
          GpraKMod6b: servicesReceived1?.gpra_k_mod_6b,
          GpraKMod6c: servicesReceived1?.gpra_k_mod_6c,
          GpraKMod6d: servicesReceived1?.gpra_k_mod_6d,
          GpraKMod6e: servicesReceived1?.gpra_k_mod_6e,
          GpraKMod6f: servicesReceived1?.gpra_k_mod_6f,
          GpraKMod6g: servicesReceived1?.gpra_k_mod_6g,
          GpraKMod6h: servicesReceived1?.gpra_k_mod_6h,
          GpraKMod6i: servicesReceived1?.gpra_k_mod_6i,
          GpraKMod7: servicesReceived1?.gpra_k_mod_7,
          GpraKMod8a: servicesReceived1?.gpra_k_mod_8a,
          GpraKMod8b: servicesReceived1?.gpra_k_mod_8b,
          GpraKMod8c: servicesReceived1?.gpra_k_mod_8c,
          GpraKMod9: servicesReceived1?.gpra_k_mod_9,
          GpraKMod10: servicesReceived1?.gpra_k_mod_10,
          GpraKMod11: servicesReceived1?.gpra_k_mod_11,
          GpraKMod11a: servicesReceived1?.gpra_k_mod_11a,
          GpraInterviewId:
            interview[INTERVIEW_SECTIONS.RECORD_MGMT].interview_id,
          GpraKId: servicesReceived1?.gpra_k_id,
          Additional: getAdditionalQuestions(servicesReceived1),
          EditMode: editMode,
          EditedBy: userCtx.session?.user?.staff_id,
        })
          .then((response) => {
            if (response.status === 200 || response.status === 201) {
              updateInterviewValues(INTERVIEW_SECTIONS.SERVICES_RECEIVED_1, {
                ...servicesReceived1,
                gpra_k_id: response.data.gpraKId,
              })
              handleLoadNext(false)
              setNextForm(
                nextForm(sections, activeIndex, administrativeInterview)
              )
              setNavigationItem()
              handleSectionsCompleted({
                ...sectionsCompleted,
                ...{ servicesReceived1: true },
              })
            }
          })
          .catch(() => {
            handleLoadNext(false)
            showMessage(false, errorMessages.genericError, toast)
          })
      } else {
        showMessage(false, errorMessages.toastErrorDetail, toast)
      }
    }
  }

  const removeError = (key) => {
    validationErrors[key] = null
    setValidationErrors(validationErrors)
  }

  const validForm = () => {
    const errors = {}
    if (
      servicesReceived1?.gpra_k_mod_11 > 0 &&
      !servicesReceived1?.gpra_k_mod_11a &&
      showQuestion(questions, "gpra_k_mod_11")
    ) {
      errors.gpra_k_mod_11a = errorMessages.requiredMessage
    }
    setValidationErrors(
      validateQuestions(
        servicesReceived1,
        INTERVIEW_SECTIONS.SERVICES_RECEIVED_1,
        additionalQuestions,
        errors,
        questions
      )
    )
    return existsErrors(errors)
  }

  const renderDefaultMain = (question) => {
    if (question.field === "gpra_k_mod_1") {
      return (
        <>
          <div className={gpraStyles.formRow}>
            <ServicesRow
              entity={servicesReceived1}
              setEntity={setServicesReceived1}
              showNumber
              removeError={removeError}
              label={`1. Case Management`}
              summaryDisabled={disabled}
              number={servicesReceived1?.gpra_k_mod_1}
              setNumber={"gpra_k_mod_1"}
              numberError={validationErrors.gpra_k_mod_1}
              numberErrorType="gpra_k_mod_1"
              showDrop={false}
              defaultZero={question.defaultZero}
            />
          </div>
          <div className={gpraStyles.formRow}>
            <ServicesRow
              entity={servicesReceived1}
              setEntity={setServicesReceived1}
              showNumber
              removeError={removeError}
              label={`2. Intensive Outpatient Treatment`}
              summaryDisabled={disabled}
              number={servicesReceived1?.gpra_k_mod_2}
              setNumber={"gpra_k_mod_2"}
              numberError={validationErrors.gpra_k_mod_2}
              numberErrorType="gpra_k_mod_2"
              showDrop={false}
              defaultZero={question.defaultZero}
            />
          </div>
          <div className={gpraStyles.formRow}>
            <ServicesRow
              entity={servicesReceived1}
              setEntity={setServicesReceived1}
              showNumber
              removeError={removeError}
              label={`3. Inpatient/Hospital (Other Than Withdrawal Management)`}
              summaryDisabled={disabled}
              number={servicesReceived1?.gpra_k_mod_3}
              setNumber={"gpra_k_mod_3"}
              numberError={validationErrors.gpra_k_mod_3}
              numberErrorType="gpra_k_mod_3"
              showDrop={false}
              defaultZero={question.defaultZero}
            />
          </div>
          <div className={gpraStyles.formRow}>
            <ServicesRow
              entity={servicesReceived1}
              setEntity={setServicesReceived1}
              showNumber
              removeError={removeError}
              label={`4. Outpatient Therapy`}
              summaryDisabled={disabled}
              number={servicesReceived1?.gpra_k_mod_4}
              setNumber={"gpra_k_mod_4"}
              numberError={validationErrors.gpra_k_mod_4}
              numberErrorType="gpra_k_mod_4"
              showDrop={false}
              defaultZero={question.defaultZero}
            />
          </div>
          <div className={gpraStyles.formRow}>
            <ServicesRow
              entity={servicesReceived1}
              setEntity={setServicesReceived1}
              showNumber
              removeError={removeError}
              label={`5. Outreach`}
              summaryDisabled={disabled}
              number={servicesReceived1?.gpra_k_mod_5}
              setNumber={"gpra_k_mod_5"}
              numberError={validationErrors.gpra_k_mod_5}
              numberErrorType="gpra_k_mod_5"
              showDrop={false}
              defaultZero={question.defaultZero}
            />
          </div>
          <div className={gpraStyles.formRow}>
            <ServicesRow
              showDrop={false}
              showNumber={false}
              label={`6. Medication`}
              summaryDisabled={disabled}
            />
          </div>
          <div className={gpraStyles.formRow}>
            <ServicesRow
              entity={servicesReceived1}
              setEntity={setServicesReceived1}
              showNumber
              removeError={removeError}
              label="1. Methadone"
              summaryDisabled={disabled}
              number={servicesReceived1?.gpra_k_mod_6a}
              setNumber={"gpra_k_mod_6a"}
              numberError={validationErrors.gpra_k_mod_6a}
              numberErrorType="gpra_k_mod_6a"
              showDrop={false}
              indentation
              defaultZero={question.defaultZero}
            />
          </div>
          <div className={gpraStyles.formRow}>
            <ServicesRow
              entity={servicesReceived1}
              setEntity={setServicesReceived1}
              showNumber
              removeError={removeError}
              label="2. Buprenorphine"
              summaryDisabled={disabled}
              number={servicesReceived1?.gpra_k_mod_6b}
              setNumber={"gpra_k_mod_6b"}
              numberError={validationErrors.gpra_k_mod_6b}
              numberErrorType="gpra_k_mod_6b"
              showDrop={false}
              indentation
              defaultZero={question.defaultZero}
            />
          </div>
          <div className={gpraStyles.formRow}>
            <ServicesRow
              entity={servicesReceived1}
              setEntity={setServicesReceived1}
              showNumber
              removeError={removeError}
              label="3. Naltrexone – Short Acting"
              summaryDisabled={disabled}
              number={servicesReceived1?.gpra_k_mod_6c}
              setNumber={"gpra_k_mod_6c"}
              numberError={validationErrors.gpra_k_mod_6c}
              numberErrorType="gpra_k_mod_6c"
              showDrop={false}
              indentation
              defaultZero={question.defaultZero}
            />
          </div>
          <div className={gpraStyles.formRow}>
            <ServicesRow
              entity={servicesReceived1}
              setEntity={setServicesReceived1}
              showNumber
              removeError={removeError}
              label="4. Naltrexone – Long Acting"
              summaryDisabled={disabled}
              number={servicesReceived1?.gpra_k_mod_6d}
              setNumber={"gpra_k_mod_6d"}
              numberError={validationErrors.gpra_k_mod_6d}
              numberErrorType="gpra_k_mod_6d"
              showDrop={false}
              indentation
              defaultZero={question.defaultZero}
            />
          </div>
          <div className={gpraStyles.formRow}>
            <ServicesRow
              entity={servicesReceived1}
              setEntity={setServicesReceived1}
              showNumber
              removeError={removeError}
              label="5. Disulfiram"
              summaryDisabled={disabled}
              number={servicesReceived1?.gpra_k_mod_6e}
              setNumber={"gpra_k_mod_6e"}
              numberError={validationErrors.gpra_k_mod_6e}
              numberErrorType="gpra_k_mod_6e"
              indentation
              showDrop={false}
              defaultZero={question.defaultZero}
            />
          </div>
          <div className={gpraStyles.formRow}>
            <ServicesRow
              entity={servicesReceived1}
              setEntity={setServicesReceived1}
              showNumber
              removeError={removeError}
              label="6. Acamprosate"
              summaryDisabled={disabled}
              number={servicesReceived1?.gpra_k_mod_6f}
              setNumber={"gpra_k_mod_6f"}
              numberError={validationErrors.gpra_k_mod_6f}
              numberErrorType="gpra_k_mod_6f"
              showDrop={false}
              indentation
              defaultZero={question.defaultZero}
            />
          </div>
          <div className={gpraStyles.formRow}>
            <ServicesRow
              entity={servicesReceived1}
              setEntity={setServicesReceived1}
              showNumber
              removeError={removeError}
              label="7. Nicotine Replacement"
              summaryDisabled={disabled}
              number={servicesReceived1?.gpra_k_mod_6g}
              setNumber={"gpra_k_mod_6g"}
              numberError={validationErrors.gpra_k_mod_6g}
              numberErrorType="gpra_k_mod_6g"
              showDrop={false}
              indentation
              defaultZero={question.defaultZero}
            />
          </div>
          <div className={gpraStyles.formRow}>
            <ServicesRow
              entity={servicesReceived1}
              setEntity={setServicesReceived1}
              showNumber
              removeError={removeError}
              label="8. Bupropion"
              summaryDisabled={disabled}
              number={servicesReceived1?.gpra_k_mod_6h}
              setNumber={"gpra_k_mod_6h"}
              numberError={validationErrors.gpra_k_mod_6h}
              numberErrorType="gpra_k_mod_6h"
              showDrop={false}
              indentation
              defaultZero={question.defaultZero}
            />
          </div>
          <div className={gpraStyles.formRow}>
            <ServicesRow
              entity={servicesReceived1}
              setEntity={setServicesReceived1}
              showNumber
              removeError={removeError}
              label="9. Varenicline"
              summaryDisabled={disabled}
              number={servicesReceived1?.gpra_k_mod_6i}
              setNumber={"gpra_k_mod_6i"}
              numberError={validationErrors.gpra_k_mod_6i}
              numberErrorType="gpra_k_mod_6i"
              showDrop={false}
              indentation
              defaultZero={question.defaultZero}
            />
          </div>
          <div className={gpraStyles.formRow}>
            <ServicesRow
              entity={servicesReceived1}
              setEntity={setServicesReceived1}
              showNumber
              removeError={removeError}
              label={`7. Residential/Rehabilitation`}
              summaryDisabled={disabled}
              number={servicesReceived1?.gpra_k_mod_7}
              setNumber={"gpra_k_mod_7"}
              numberError={validationErrors.gpra_k_mod_7}
              numberErrorType="gpra_k_mod_7"
              showDrop={false}
              defaultZero={question.defaultZero}
            />
          </div>
          <div className={gpraStyles.formRow}>
            <ServicesRow
              showDrop={false}
              showNumber={false}
              label={`8. Withdrawal Management (Select Only One)`}
              summaryDisabled={disabled}
            />
          </div>
          <div className={gpraStyles.formRow}>
            <ServicesRow
              entity={servicesReceived1}
              setEntity={setServicesReceived1}
              showNumber
              removeError={removeError}
              label="1. Hospital Inpatient"
              summaryDisabled={disabled}
              number={servicesReceived1?.gpra_k_mod_8a}
              setNumber={"gpra_k_mod_8a"}
              numberError={validationErrors.gpra_k_mod_8a}
              numberErrorType="gpra_k_mod_8a"
              showDrop={false}
              indentation
              defaultZero={question.defaultZero}
            />
          </div>
          <div className={gpraStyles.formRow}>
            <ServicesRow
              entity={servicesReceived1}
              setEntity={setServicesReceived1}
              showNumber
              removeError={removeError}
              label="2. Free Standing Residential"
              summaryDisabled={disabled}
              number={servicesReceived1?.gpra_k_mod_8b}
              setNumber={"gpra_k_mod_8b"}
              numberError={validationErrors.gpra_k_mod_8b}
              numberErrorType="gpra_k_mod_8b"
              showDrop={false}
              indentation
              defaultZero={question.defaultZero}
            />
          </div>
          <div className={gpraStyles.formRow}>
            <ServicesRow
              entity={servicesReceived1}
              setEntity={setServicesReceived1}
              showNumber
              removeError={removeError}
              label="3. Ambulatory Detoxification"
              summaryDisabled={disabled}
              number={servicesReceived1?.gpra_k_mod_8c}
              setNumber={"gpra_k_mod_8c"}
              numberError={validationErrors.gpra_k_mod_8c}
              numberErrorType="gpra_k_mod_8c"
              showDrop={false}
              indentation
              defaultZero={question.defaultZero}
            />
          </div>
          <div className={gpraStyles.formRow}>
            <ServicesRow
              entity={servicesReceived1}
              setEntity={setServicesReceived1}
              showNumber
              removeError={removeError}
              label={`9. After Care`}
              summaryDisabled={disabled}
              number={servicesReceived1?.gpra_k_mod_9}
              setNumber={"gpra_k_mod_9"}
              numberError={validationErrors.gpra_k_mod_9}
              numberErrorType="gpra_k_mod_9"
              showDrop={false}
              defaultZero={question.defaultZero}
            />
          </div>
          <div className={gpraStyles.formRow}>
            <ServicesRow
              entity={servicesReceived1}
              setEntity={setServicesReceived1}
              showNumber
              removeError={removeError}
              label={`10. Recovery Support`}
              summaryDisabled={disabled}
              number={servicesReceived1?.gpra_k_mod_10}
              setNumber={"gpra_k_mod_10"}
              numberError={validationErrors.gpra_k_mod_10}
              numberErrorType="gpra_k_mod_10"
              showDrop={false}
              defaultZero={question.defaultZero}
            />
          </div>
          <div className={gpraStyles.formRow}>
            <ServicesRow
              entity={servicesReceived1}
              setEntity={setServicesReceived1}
              showNumber
              removeError={removeError}
              label={`11. Other (Specify)`}
              summaryDisabled={disabled}
              number={servicesReceived1?.gpra_k_mod_11}
              setNumber={"gpra_k_mod_11"}
              numberError={validationErrors.gpra_k_mod_11}
              numberErrorType="gpra_k_mod_11"
              showDrop={false}
              extraValues={[{ key: "gpra_k_mod_11a", value: "" }]}
              defaultZero={question.defaultZero}
            />
          </div>
          {servicesReceived1?.gpra_k_mod_11 > 0 && (
            <div className={gpraStyles.formRow}>
              <InputText
                className={
                  validationErrors.gpra_k_mod_11a
                    ? gpraStyles.inputText5Error
                    : gpraStyles.inputText5
                }
                disabled={disabled}
                placeholder={
                  !servicesReceived1?.gpra_k_mod_11 ? "Not Applicable" : ""
                }
                value={servicesReceived1?.gpra_k_mod_11a}
                onChange={(e) => {
                  updateState(
                    "gpra_k_mod_11_a",
                    e.target.value,
                    null,
                    null,
                    servicesReceived1,
                    setServicesReceived1,
                    null
                  )
                  removeError("gpra_k_mod_11a")
                }}
              />
              <FormError error={validationErrors.gpra_k_mod_11a} />
            </div>
          )}
        </>
      )
    }
  }
  
  return (
    <div>
      <Toast ref={toast} />
      {showToolBar && (
        <Toolbar
          className={gpraStyles.mb2}
          right={
            <CustomToolBar
              toast={toast}
              prevForm={true}
              saveData={saveData}
              nextForm={true}
            />
          }
        ></Toolbar>
      )}
      <Fieldset
        legend="K. SERVICES RECEIVED UNDER GRANT FUNDING"
        style={{ marginBottom: "1rem" }}
      >
        <div className={gpraStyles.grid}>
          <div className={gpraStyles.formRow}>
            <FormLabel
              label={
                "Identify the number of DAYS of services provided to the client  during the client’s course of treatment/recovery."
              }
            />
          </div>
          <div className={gpraStyles.formRow}>
            <FormLabel label={"Modality [SELECT AT LEAST ONE MODALITY.]"} />
          </div>
          {mixedQuestions?.map((question) => {
            if (question.kind === "default") {
              if (question.show) {
                return renderDefaultMain(question)
              }
            } else {
              if (
                checkConditionalRender(
                  question.enabled,
                  question.required,
                  question.kind,
                  question.conditionalSource
                )
              ) {
                return (
                  <AdditionalQuestionContainer
                    entity={servicesReceived1}
                    setEntity={setServicesReceived1}
                    errors={validationErrors}
                    section={INTERVIEW_SECTIONS.SERVICES_RECEIVED_1}
                    removeError={removeError}
                    disabled={disabled}
                    question={question.question}
                    number={question.number}
                    kind={question.kind}
                  />
                )
              } else {
                if (checkDisplayConditional(question, servicesReceived1)) {
                  return (
                    <AdditionalQuestionContainer
                      entity={servicesReceived1}
                      setEntity={setServicesReceived1}
                      errors={validationErrors}
                      section={INTERVIEW_SECTIONS.SERVICES_RECEIVED_1}
                      removeError={removeError}
                      disabled={disabled}
                      question={question.question}
                      number={question.number}
                      kind={question.kind}
                    />
                  )
                }
              }
            }
          })}
        </div>
      </Fieldset>
      {showToolBar && (
        <Toolbar
          className={gpraStyles.mt2}
          right={
            <CustomToolBar
              toast={toast}
              prevForm={true}
              saveData={saveData}
              nextForm={true}
            />
          }
        ></Toolbar>
      )}
    </div>
  )
}

ServicesReceived1.propTypes = {
  showToolBar: PropTypes.bool,
  disabled: PropTypes.bool,
}

ServicesReceived1.defaultProps = {
  showToolBar: true,
  disabled: false,
}

export default ServicesReceived1
